import { TYPE_OF_USER, TYPE_OF_USER_FM, TYPE_OF_USER_MOVING } from "../../../../../../constants";

export const getTypes = (isMoving: boolean, isFMVersion: boolean) => {
  if (isMoving) {
    return TYPE_OF_USER_MOVING;
  }
  if (isFMVersion) {
    return TYPE_OF_USER_FM;
  }

  return TYPE_OF_USER;
};
